import { round } from "lodash";
import { SidePanel } from "../SidePanel";
import { renderNumber } from "../../utils";
import { useTranslation } from "react-i18next";
import "./style.scss";

export const CockpitSidePanel = ({
  title,
  score,
  benchmark,
  difference,
  description,
}: {
  title?: string;
  score?: number;
  benchmark?: number;
  difference?: number;
  description?: string;
}) => {
  const { t } = useTranslation();

  return (
    <SidePanel active={true} title={title ?? "N/A"} direction="right">
      <div className="side-panel-row">
        <div className="item">
          <div className="label">
            {t("frontend.futurebilityCockpit.score", "Score")}
          </div>
          <div className="value">{round(score ?? 0)}%</div>
        </div>
        <div className="item">
          <div className="label">
            {t("frontend.futurebilityCockpit.benchmark", "Benchmark")}
          </div>
          <div className="value">{round(benchmark ?? 0)}%</div>
        </div>
        <div className="circle">{renderNumber(difference ?? 0, true)}%</div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: description ?? "N/A" }} />
    </SidePanel>
  );
};
